export default {"src":"/_next/static/image/public/images/flags/flag_974.1870d255983f979de39c064bf5b48cda.svg","height":16,"width":24};